import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CxAlertsService {
  // visibility
  private visibilityAlertSuccessSubject = new BehaviorSubject(false);
  private visibilityAlertWarnSubject = new BehaviorSubject(false);
  private visibilityAlertInfoSubject = new BehaviorSubject(false);
  visibilityAlertSuccess = this.visibilityAlertSuccessSubject.asObservable();
  visibilityAlertWarn = this.visibilityAlertWarnSubject.asObservable();
  visibilityAlertInfo = this.visibilityAlertInfoSubject.asObservable();
  // Messages
  private messageAlertSuccessSubject = new BehaviorSubject('');
  private messageAlertInfoSubject = new BehaviorSubject('');
  private messageAlertWarnSubject = new BehaviorSubject('');
  messageAlertSuccess = this.messageAlertSuccessSubject.asObservable();
  messageAlertWarn = this.messageAlertWarnSubject.asObservable();
  messageAlertInfo = this.messageAlertInfoSubject.asObservable();

  constructor() {}

  // Open
  openAlertSuccess(message: string): void {
    this.updateVisibilityAlertSuccess(true);
    this.updateMessageAlertSuccess(message);
    this.focusAlert();
    this.autoCloseAlert('success');
  }

  openAlertWarn(message: string): void {
    this.updateVisibilityAlertWarn(true);
    this.updateMessageAlertWarn(message);
    this.focusAlert();
    this.autoCloseAlert('warn');
  }

  openAlertInfo(message: string): void {
    this.updateVisibilityAlertInfo(true);
    this.updateMessageAlertInfo(message);
    this.focusAlert();
    this.autoCloseAlert('info');
  }

  private focusAlert(): void {
    location.href = location.href + '#messageContent';
  }

  closeAllAlerts(): void {
    this.closeAlertSuccess();
    this.closeAlertWarn();
    this.closeAlertInfo();
  }

  closeAlert(typeAlert: string): void {
    switch (typeAlert) {
      case 'success': {
        this.closeAlertSuccess();
        break;
      }
      case 'warn': {
        this.closeAlertWarn();
        break;
      }
      case 'info': {
        this.closeAlertInfo();
        break;
      }
    }
  }

  private closeAlertSuccess(): void {
    this.updateVisibilityAlertSuccess(false);
  }

  private closeAlertWarn(): void {
    this.updateVisibilityAlertWarn(false);
  }

  private closeAlertInfo(): void {
    this.updateVisibilityAlertInfo(false);
  }

  private autoCloseAlert(typeAlert: string): void {
    setTimeout(() => {
      this.closeAlert(typeAlert);
    }, 10000);
  }

  private updateVisibilityAlertSuccess(visibility: boolean): void {
    this.visibilityAlertSuccessSubject.next(visibility);
  }

  private updateVisibilityAlertWarn(visibility: boolean): void {
    this.visibilityAlertWarnSubject.next(visibility);
  }

  private updateVisibilityAlertInfo(visibility: boolean): void {
    this.visibilityAlertInfoSubject.next(visibility);
  }

  private updateMessageAlertSuccess(message: string): void {
    this.messageAlertSuccessSubject.next(message);
  }

  private updateMessageAlertWarn(message: string): void {
    this.messageAlertWarnSubject.next(message);
  }

  private updateMessageAlertInfo(message: string): void {
    this.messageAlertInfoSubject.next(message);
  }
}
